var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "28px",
    viewBox: "0 0 21 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    transform: "translate(-1077.000000, -196.000000)",
    fill: "#FF4A4A",
    fillRule: "nonzero",
    stroke: "#323232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(1078.000000, 192.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.72222222,5 C4.3527643,5 0,9.39461283 0,14.815694           C0,23.0709764 9.72222222,30.6666667 9.72222222,30.6666667           C9.72222222,30.6666667 19.4444444,23.0710281 19.4444444,14.815694           C19.4444444,9.39461283 15.0916801,5 9.72222222,5 Z           M9.72222222,18.7306927 C7.58064889,18.7306927 5.84455604,16.9779086           5.84455604,14.8157457 C5.84455604,12.6535827 7.58064889,10.9007987           9.72222222,10.9007987 C11.8637956,10.9007987 13.5998884,12.6535827           13.5998884,14.8157457 C13.5998884,16.9779086 11.8637956,18.7306927           9.72222222,18.7306927 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.02ad9310e6911717fc79718999ef4e7b.svg";
export { ForwardRef as ReactComponent };